
import { fetchInvitations } from "./invitation/fetchInvitations";
import { createEmployeeInvitation } from "./invitation/createInvitation";
import { acceptInvitation } from "./invitation/acceptInvitation";
import { revokeInvitation } from "./invitation/revokeInvitation";
import { sendInvitationEmail } from "./invitation/sendInvitationEmail";

const invitationService = {
  fetchInvitations,
  createInvitation: createEmployeeInvitation,
  acceptInvitation,
  revokeInvitation,
  sendInvitationEmail
};

export default invitationService;
